module.exports = __webpack_public_path__ + "img/load-icon4.763da3df.png";